import request from "@/common/request"
import { Page, GrupoDeCliente } from "@/models"
import { AxiosRequestConfig } from "axios"

const basePath = '/grupo-de-cliente'

export const findPageGrupoDeCliente = (params?: any, config?: AxiosRequestConfig): Promise<Page<GrupoDeCliente>> => 
	request.get(`${basePath}`, {params, ...config})

export const criarGrupoDeCliente = (grupoDeCliente: GrupoDeCliente): Promise<GrupoDeCliente> =>
	request.post(`${basePath}/criar`, grupoDeCliente)

export const atualizarGrupoDeCliente = (grupoDeCliente: GrupoDeCliente): Promise<GrupoDeCliente> =>
	request.post(`${basePath}/atualizar/${grupoDeCliente.id}`, grupoDeCliente)

export const deletarGrupoDeCliente = (grupoDeClienteId: string): Promise<void> =>
	request.delete(`${basePath}/deletar/${grupoDeClienteId}`)

export const listarGruposDeCliente = (params?: any, config?: AxiosRequestConfig): Promise<GrupoDeCliente[]> => 
	request.get(`${basePath}/listar`, {params, ...config})

export const findGruposVinculadosComCliente = (params?: any, config?: AxiosRequestConfig): Promise<Page<GrupoDeCliente>> => 
	request.get(`${basePath}/cliente`, {params, ...config})

export const possuiGrupoDeClienteByGrupoEconomico = (clienteId: string, grupoId: string): Promise<boolean> =>
	request.get(`${basePath}/${clienteId}/existe-vinculo/${grupoId}`)

export const vincularGrupoDeCliente = (clienteId: string, grupoId: string): Promise<void> =>
	request.post(`${basePath}/${clienteId}/vincular/${grupoId}`)

export const desvincularGrupoDeCliente = (grupoId: string, clienteId: string): Promise<void> =>
	request.post(`${basePath}/${grupoId}/desvincular/${clienteId}`)